module.exports = __webpack_public_path__ + "img/reset-image.6005f11c.svg";